<template>
  <div>
    <router-btn
      :text="isActive ? $t('servicesystem.common_objects.commonterms.disable') : $t('servicesystem.common_objects.commonterms.re_activate')"
      :icon="isActive ? 'mdi-minus-circle' : 'mdi-plus-circle'" :color="isActive ? 'error' : 'success'" :disabled="false"
      :outlined="false" :textbtn="textbtn" :large="large" :small="small" :loading="loading" @Press="action()">
    </router-btn>
  </div>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "ToggleContractActiveBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
  },
  mixins: [clientAPI],

  data() {
    return {
      loading: true,
      isActive: true,
    };
  },

  mounted() {
    this.getActiveState();
  },

  methods: {
    async getActiveState() {
      this.loading = true;
      this.isActive = await clientAPI.methods.getContractActiveById(this.contractId).finally(() => {
        this.loading = false;
      });
      //console.log('get result', this.isActive);
    },

    async toggleActiveState() {
      await clientAPI.methods.toggleContractActiveById(this.contractId)
        .then(result => {
          this.isActive = result;
          //this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
        }).finally(() => {
          this.loading = false;
        });
    },

    async action() {
      await this.toggleActiveState();
    },
  },

  computed: {
    contractId() {
      return this.$route.params.contractId;
    }
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
